import { CloseRounded } from '@mui/icons-material';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import { variants } from '../../../../variants/variants';
import DatePicker from './DatePicker';
import { useChangeStatusMutation, useGetAllEmployeesForJuryQuery } from '../../giftApiSlice';
import { Stack } from '@mui/material';
import { Typography } from '@mui/material';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';

const ApproveDialog = ({
  selected,
  title,
  open,
  handleClose,
  label,
  selectEmployees,
  textarea,
  status,
  reject = false,
}) => {
  const { data } = useGetAllEmployeesForJuryQuery();
  const [approveApplication] = useChangeStatusMutation();
  const [jury, setJury] = useState([]);
  const [date, setDate] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const handleDateChange = (value) => {
    setDate(value);
  };
  const handleRemarkChange = (e) => {
    const value = e.target.value;
    setRemarks(value);
  };
  const handleChange = (newValue) => {
    let newJury = newValue.map((jury) => jury?.empCode);
    setJury(newJury);
  };
  const onClose = () => {
    handleClose();
    setJury({});
    setRemarks(null);
    setDate(null);
  };
  const handleSubmit = async () => {
    try {
      let body = {
        status,
        jury,
        meetingDate: date,
      };
      let successToast = 'Application approved!';
      if (reject) {
        successToast = 'Application rejected!';
        body.reason = remarks;
      }

      if (status === 'Requires_changes') {
        successToast = 'Application reverted!';
        body.remarks = remarks;
      }

      const data = await approveApplication({ id: selected, body }).unwrap();
      onClose();
      toast.success(selectEmployees ? 'Meeting scheduled!' : successToast);
    } catch (err) {
      console.log(err);
      toast.error('An error occurred');
    }
  };
  const canAdminSubmit = Boolean(jury.length > 1 && date);
  const canManagerSubmit = Boolean(remarks);
  return (
    <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
      <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider', mb: 1, p: 1 }}>
        <Stack direction='row' alignItems={'center'}>
          <Typography>{title}</Typography>
          <IconButton sx={{ ml: 'auto' }} {...(open && { className: 'backButton' })} onClick={onClose}>
            <CloseRounded fontSize='small' />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 1.5 }}>
        <Typography sx={{ fontSize: variants.BODY, color: variants.typography.inactive.hover, mb: 1 }}>
          {label}
        </Typography>
        {textarea && (
          <TextField
            value={remarks}
            onChange={handleRemarkChange}
            placeholder={'Specific inputs'}
            multiline
            fullWidth
            maxRows={10}
            rows={4}
          />
        )}
        {selectEmployees && (
          <>
            <Autocomplete
              multiple
              limitTags={2}
              options={data}
              disableCloseOnSelect
              getOptionLabel={(option) => `${option.empName} - ${option?.empCode}`}
              onChange={(e, value) => handleChange(value)}
              renderInput={(params, option) => (
                <TextField
                  {...params}
                  margin='dense'
                  variant='outlined'
                  label={'Technical jury members'}
                  InputLabelProps={{ style: { fontSize: variants.fontSize.SUB_HEADING } }}
                  InputProps={{ ...params.InputProps, style: { fontSize: variants.fontSize.SUB_HEADING } }}
                />
              )}
            />
            <DatePicker handleDateChange={handleDateChange} />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: 1, borderColor: 'divider' }}>
        <Button
          onClick={handleSubmit}
          size='small'
          variant='contained'
          disabled={selectEmployees ? !canAdminSubmit : !canManagerSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveDialog;
